import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, GraduationCap, MapPin, MessageCircle, AlertTriangle, ArrowRight } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Offer() {
  return <div className="bg-brand-ivory py-24" id="servicio" data-id="element-129">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        {/* SECCIÓN 9: EL STACK DE OFERTA */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24" data-id="element-131">
          <div className="text-center mb-16" data-id="element-132">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-133">
              Elegí tu camino
            </h2>
            <div className="w-24 h-px bg-brand-gold mx-auto" data-id="element-134"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-135">
            {/* Tarjeta Servicio */}
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-brand-cream relative overflow-hidden group hover:border-brand-gold/50 transition-colors" data-id="element-136">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-blush/10 rounded-bl-full -z-10 group-hover:bg-brand-blush/20 transition-colors" data-id="element-137"></div>

              <div className="flex items-center gap-4 mb-6" data-id="element-138">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center text-brand-gold" data-id="element-139">
                  <Sparkles size={24} data-id="element-140" />
                </div>
                <h3 className="text-2xl font-serif text-brand-charcoal" data-id="element-141">
                  Servicio
                </h3>
              </div>

              <h4 className="text-xl font-medium text-brand-charcoal mb-3" data-id="element-142">
                Manicura Profesional con Avril
              </h4>
              <p className="text-brand-charcoal/70 mb-8 min-h-[48px]" data-id="element-143">
                Para las que quieren uñas que duren de verdad, con un servicio
                que las haga sentir especiales.
              </p>

              <div className="space-y-4 mb-10" data-id="element-144">
                <p className="font-medium text-sm text-brand-gold uppercase tracking-wider" data-id="element-145">
                  Incluye:
                </p>
                <ul className="space-y-3 text-brand-charcoal/80" data-id="element-146">
                  <li className="flex gap-3" data-id="element-147">
                    <span className="text-brand-gold" data-id="element-148">•</span> Atención
                    personalizada en su espacio profesional
                  </li>
                  <li className="flex gap-3" data-id="element-149">
                    <span className="text-brand-gold" data-id="element-150">•</span> Técnica de
                    duración +21 días
                  </li>
                  <li className="flex gap-3" data-id="element-151">
                    <span className="text-brand-gold" data-id="element-152">•</span> Resultado que
                    podés mostrar con orgullo
                  </li>
                </ul>
              </div>

              <div className="flex items-center gap-2 text-brand-charcoal/60 text-sm mb-8" data-id="element-153">
                <MapPin size={16} data-id="element-154" />
                <span data-id="element-155">18 de Julio 1358 | Paysandú</span>
              </div>

              <a href="#contacto" className="block w-full text-center bg-brand-charcoal text-white py-4 rounded-full font-medium hover:bg-black transition-colors" data-id="element-156">
                Reservar turno
              </a>
            </div>

            {/* Tarjeta Curso */}
            <div className="bg-brand-charcoal text-white rounded-3xl p-8 md:p-10 shadow-xl relative overflow-hidden" id="curso" data-id="element-157">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-bl-full -z-10" data-id="element-158"></div>

              <div className="flex items-center gap-4 mb-6" data-id="element-159">
                <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center text-brand-gold" data-id="element-160">
                  <GraduationCap size={24} data-id="element-161" />
                </div>
                <h3 className="text-2xl font-serif text-brand-cream" data-id="element-162">
                  Formación
                </h3>
              </div>

              <h4 className="text-xl font-medium text-brand-cream mb-3" data-id="element-163">
                Curso de Manicura Profesional
              </h4>
              <p className="text-brand-cream/70 mb-8 min-h-[48px]" data-id="element-164">
                Para las que quieren convertir su pasión en un negocio real.
              </p>

              <div className="space-y-4 mb-10" data-id="element-165">
                <p className="font-medium text-sm text-brand-gold uppercase tracking-wider" data-id="element-166">
                  Incluye:
                </p>
                <ul className="space-y-3 text-brand-cream/90" data-id="element-167">
                  <li className="flex gap-3" data-id="element-168">
                    <span className="text-brand-gold" data-id="element-169">•</span> Técnica completa
                    paso a paso
                  </li>
                  <li className="flex gap-3" data-id="element-170">
                    <span className="text-brand-gold" data-id="element-171">•</span> Corrección
                    personalizada
                  </li>
                  <li className="flex gap-3" data-id="element-172">
                    <span className="text-brand-gold" data-id="element-173">•</span> Formación con una
                    profesional activa en el mercado
                  </li>
                  <li className="flex gap-3" data-id="element-174">
                    <span className="text-brand-gold" data-id="element-175">•</span> Todo lo que
                    necesitás para empezar a trabajar
                  </li>
                </ul>
              </div>

              <div className="flex items-center gap-2 text-brand-cream/60 text-sm mb-8" data-id="element-176">
                <MessageCircle size={16} data-id="element-177" />
                <span data-id="element-178">Consultas e inscripciones disponibles</span>
              </div>

              <a href="#contacto" className="block w-full text-center bg-brand-gold text-white py-4 rounded-full font-medium hover:bg-brand-goldDark transition-colors" data-id="element-179">
                Consultar por el curso
              </a>
            </div>
          </div>
        </motion.section>

        {/* SECCIÓN 10: INVERSIÓN DE RIESGO CERO */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24 text-center max-w-3xl mx-auto" data-id="element-180">
          <h2 className="text-2xl md:text-3xl font-serif text-brand-charcoal mb-6" data-id="element-181">
            Avril no te va a pedir que confíes a ciegas.
          </h2>
          <div className="space-y-4 text-brand-charcoal/80" data-id="element-182">
            <p data-id="element-183">
              Su trabajo habla por ella. Sus alumnas hablan por ella. Sus
              clientas que vuelven cada 3 semanas hablan por ella.
            </p>
            <p data-id="element-184">
              Por eso, si tenés dudas, podés consultarle antes de inscribirte.
              Sin presión. Sin scripts de venta.
            </p>
            <p className="font-medium text-brand-charcoal pt-4" data-id="element-185">
              Solo una conversación honesta entre profesional y futura alumna.
            </p>
          </div>
        </motion.section>

        {/* SECCIÓN 11: URGENCIA & ESCASEZ */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24 max-w-3xl mx-auto" data-id="element-186">
          <div className="bg-brand-cream rounded-2xl p-6 md:p-8 space-y-6 border border-brand-gold/20" data-id="element-187">
            <div className="flex gap-4 items-start" data-id="element-188">
              <AlertTriangle className="text-brand-gold w-6 h-6 flex-shrink-0 mt-1" data-id="element-189" />
              <p className="text-brand-charcoal/90" data-id="element-190">
                <strong className="text-brand-charcoal" data-id="element-191">
                  Los turnos de Avril se llenan.
                </strong>{' '}
                No es marketing. Es consecuencia de hacer bien el trabajo.
              </p>
            </div>
            <div className="flex gap-4 items-start" data-id="element-192">
              <AlertTriangle className="text-brand-gold w-6 h-6 flex-shrink-0 mt-1" data-id="element-193" />
              <p className="text-brand-charcoal/90" data-id="element-194">
                <strong className="text-brand-charcoal" data-id="element-195">
                  Los cupos del curso son limitados por una razón:
                </strong>{' '}
                para que cada alumna reciba atención real, no masiva.
              </p>
            </div>
          </div>

          <div className="text-center mt-10" data-id="element-196">
            <p className="text-xl font-serif text-brand-charcoal mb-2" data-id="element-197">
              Si llegaste hasta acá, algo en esto resonó con vos.
            </p>
            <p className="text-brand-charcoal/70" data-id="element-198">
              No lo dejes para mañana. Las agendas llenas no esperan.
            </p>
          </div>
        </motion.section>

        {/* SECCIÓN 12: LLAMADO A LA ACCIÓN */}
        <motion.section id="contacto" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-4xl mx-auto" data-id="element-199">
          <div className="bg-brand-blush/20 rounded-3xl p-8 md:p-12 border border-brand-rose/20" data-id="element-200">
            <div className="grid md:grid-cols-2 gap-12" data-id="element-201">
              <div className="space-y-6" data-id="element-202">
                <h3 className="text-2xl font-serif text-brand-charcoal" data-id="element-203">
                  🎯 ¿Querés uñas que duren +21 días?
                </h3>
                <p className="text-brand-charcoal/80" data-id="element-204">
                  Reservá tu turno ahora mismo.
                </p>
                <div className="space-y-2 text-sm text-brand-charcoal/70" data-id="element-205">
                  <p className="flex items-center gap-2" data-id="element-206">
                    <MapPin size={16} className="text-brand-gold" data-id="element-207" /> 18 de Julio
                    1358, Paysandú
                  </p>
                  <p className="flex items-center gap-2" data-id="element-208">
                    <MessageCircle size={16} className="text-brand-gold" data-id="element-209" />{' '}
                    Escribinos directo o entrá al link de la bio
                  </p>
                </div>
                <a href="#" className="inline-flex items-center justify-center gap-2 w-full bg-brand-charcoal text-white py-3 rounded-full font-medium hover:bg-black transition-colors" data-id="element-210">
                  Agendar turno <ArrowRight size={18} data-id="element-211" />
                </a>
              </div>

              <div className="space-y-6" data-id="element-212">
                <h3 className="text-2xl font-serif text-brand-charcoal" data-id="element-213">
                  🎯 ¿Querés aprender y tener tu propio negocio?
                </h3>
                <p className="text-brand-charcoal/80" data-id="element-214">
                  Consultá por el curso de manicura. Cupos limitados. Formación
                  real. Resultados comprobados.
                </p>
                <div className="space-y-2 text-sm text-brand-charcoal/70" data-id="element-215">
                  <p className="flex items-center gap-2" data-id="element-216">
                    <MessageCircle size={16} className="text-brand-gold" data-id="element-217" /> Un
                    mensaje es todo lo que separa tu situación actual de la que
                    querés tener.
                  </p>
                </div>
                <a href="#" className="inline-flex items-center justify-center gap-2 w-full bg-brand-gold text-white py-3 rounded-full font-medium hover:bg-brand-goldDark transition-colors" data-id="element-218">
                  Consultar curso <ArrowRight size={18} data-id="element-219" />
                </a>
              </div>
            </div>

            <div className="mt-12 text-center pt-8 border-t border-brand-rose/20" data-id="element-220">
              <p className="text-2xl font-serif text-brand-charcoal italic" data-id="element-221">
                El momento perfecto no existe.{' '}
                <span className="text-brand-goldDark" data-id="element-222">
                  Pero este momento sí.
                </span>
              </p>
            </div>
          </div>
        </motion.section>
      </div>
    </div>;
}